import type { ReactNode } from "react";
import { Menu } from "@headlessui/react";
import type { LinkProps } from "react-router-dom";
import { ItemLink } from "./ItemLink";

export interface ItemWithLinkProps {
  [key: string]: any;
  active?: boolean;
  as?: "a" | "button";
  children: ReactNode;
  hasDanger?: boolean;
  linkType?: "button" | "submit" | "reset";
  onClick?: (event: any) => void;
  role?: string;
  to?: LinkProps["to"];
}

export const ItemWithLink = ({
  children,
  active: isActiveProp,
  onClick,
  to,
  as,
  ...rest
}: ItemWithLinkProps) => (
  <Menu.Item as={as} onClick={onClick}>
    {({ active }) => (
      <ItemLink to={to} active={active || isActiveProp} {...rest}>
        {children}
      </ItemLink>
    )}
  </Menu.Item>
);
